import { render, staticRenderFns } from "./sim-serial.vue?vue&type=template&id=20813150&"
import script from "./sim-serial.vue?vue&type=script&lang=js&"
export * from "./sim-serial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports